export const LOAD_GENERIC_PARAMETERS = 'LOAD_GENERIC_PARAMETERS';
export const SET_GENERIC_PARAMETERS = 'SET_GENERIC_PARAMETERS';
export const SAVE_GENERIC_PARAMETER = 'SAVE_GENERIC_PARAMETER';
export const SAVED_GENERIC_PARAMETER = 'SAVED_GENERIC_PARAMETER';

export const loadGenericParameters = () => ({ type: LOAD_GENERIC_PARAMETERS });

export const setGenericParameters = (parameters) => ({
    type: SET_GENERIC_PARAMETERS,
    parameters,
});

export const saveGenericParameter = (parameter) => ({
    type: SAVE_GENERIC_PARAMETER,
    parameter,
});

export const savedGenericParameter = (parameter) => ({
    type: SAVED_GENERIC_PARAMETER,
    parameter,
});

const initialState = { parameters: [] };

export default (state = initialState, action) => {
    switch (action.type) {
    case SAVED_GENERIC_PARAMETER: {
        const { parameter } = action;
        const index = state.parameters.findIndex((p) => p.id === parameter.id);
        if (index === -1) {
            return { ...state, parameters: state.parameters.concat(parameter) };
        }
        return {
            ...state,
            parameters: state.parameters
                .slice(0, index)
                .concat([parameter])
                .concat(state.parameters.slice(index + 1)),
        };
    }
    case SET_GENERIC_PARAMETERS:
        return { ...state, parameters: action.parameters };
    default:
        return state;
    }
};
